import { render, staticRenderFns } from "./relateLogisticsOrderDialog.vue?vue&type=template&id=168a463d&scoped=true"
import script from "./relateLogisticsOrderDialog.vue?vue&type=script&lang=js"
export * from "./relateLogisticsOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a463d",
  null
  
)

export default component.exports